import { CircularProgress, Stack, Typography } from "@mui/material";

export default function Spinner({text, color = "primary", size=32, sx}){
    return (<>
        <Stack direction="row" sx={{p: 2, width: "100%", height: "100%", ...sx}} alignContent="center" justifyContent="center">
            <Stack direction="column" sx={{textAlign: "center"}} alignContent="center" justifyContent="center" alignItems="center">
                <CircularProgress color={color} size={size}/>
                <Typography variant="caption" sx={{color: 'text.disabled', mt: 2}}>{text}</Typography>
            </Stack>
        </Stack>
    </>)
}